
/**
 * @see "Section 4, OFX spec"
 */
export enum ApplicationSecurity {

  NONE,

  TYPE1
}
